import { render, staticRenderFns } from "./Ruler.vue?vue&type=template&id=640c74c2&scoped=true"
import script from "./Ruler.vue?vue&type=script&lang=ts"
export * from "./Ruler.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Ruler.vue?vue&type=style&index=0&id=640c74c2&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "640c74c2",
  null
  ,true
)

export default component.exports